import ConfirmationPageContainer from './ConfirmationPageContainer';

export default ConfirmationPageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ConfirmationPage/index.js